import { render, staticRenderFns } from "./wxLogin_view.vue?vue&type=template&id=7c62eb36&scoped=true&"
import script from "./wxLogin_view.vue?vue&type=script&lang=js&"
export * from "./wxLogin_view.vue?vue&type=script&lang=js&"
import style0 from "./wxLogin_view.vue?vue&type=style&index=0&id=7c62eb36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62eb36",
  null
  
)

export default component.exports